<script setup lang="ts">
  import { useStorage } from '@vueuse/core'
  import InitColors from './components/ui/init-colors/index.vue'

  const primaryColor = useStorage('primaryColor', 'blue')
</script>

<template>
  <NuxtLoadingIndicator :throttle="0" :color="primaryColor" />
  <UApp>
    <NuxtLayout />
    <InitColors hidden />
  </UApp>
</template>
